import React, {Component} from 'react';

import {Modal} from '@material-ui/core';

import cross from '../../assets/cross.png';
import './styles.scss';
import LoadingSpinner from "../spinner/Spinner";

export default class CustomModal extends Component {

    render() {

        let {open, onClose, text, subtext, cancel, accept, acceptText, cancelText, loading} = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={onClose}
                className={'modal-container'}
            >
                <div className="modal-section">
                    <div className={'close-cross'} onClick={cancel}>
                        <img src={cross} alt={'Cerrar'} />
                    </div>
                    <div className="text">{text}</div>
                    <div className="subtext">{subtext}</div>
                    <div className="text-center btns">
                        {cancel && !loading &&
                        <div className="btn btn-cancel" onClick={cancel}>{cancelText}</div>
                        }
                        {accept && !loading &&
                        <div className="btn btn-accept" onClick={accept}>{acceptText}</div>
                        }
                        {loading &&
                        <LoadingSpinner width={50}/>
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

CustomModal.defaultProps = {
    open: false,
    onClose: () => {},
    text: '',
    subtext: '',
    loading: false,
    cancel: false,
    accept: false,
    acceptText: 'Aceptar',
    cancelText: 'Cancelar',
};


// WEBPACK FOOTER //
// ./src/components/modal/Modal.js